import EDHttp from '../utils/EDHttp';
import Auth from './auth';
export default 
{
    async getAnalysisV2(id, includeContribution, getLockedAnalysis) {
        try {
            let query = `?includeContribution=${includeContribution ? 1 : 0}`
            if (getLockedAnalysis) {
                query += `&locked=1`
            }
            const { data } = await EDHttp.get(`/api/v2/analysis/${id}${query}`);
            return data.data;
        } catch ({ response }) {
            throw response.data.message;
        }
    },

    update: function (id, updates) {
        return new Promise(async (resolve, reject) => {
            try {
                const result = await EDHttp.put(`/api/v2/analysis/${id}/${Auth.account.id}`, { updates });
                if (result && !result.data.error) {
                    return resolve(result.data.data);
                }
                reject('Error');
            } catch (error) {
                reject(error)
            }

        })
    },
    async getCustomAnalysisPreview (id, updates) {
        try {
            const result = await EDHttp.put(`/api/v2/analysis/custom-analysis-preview/${id}`, { updates });
            return result.data.data;
        } catch (error) {
            if (error.response) {
                throw error.response.data.message;
            }
            throw 'Please check your internet connection';
        }
    },
    async getExtraPaymentPreview (id, data) {
        try {
            const result = await EDHttp.put(`/api/v2/analysis/extra-payment-preview/${id}`, { data });
            return result.data.data;
        } catch (error) {
            if (error.response) {
                throw error.response.data.message;
            }
            throw 'Please check your internet connection';
        }
    },
    getStrategy:function(id)
    {
        return new Promise((resolve,reject)=>
        {
            EDHttp.get(`/api/strategy/${id}`).then(result=>
                {
                    if(result&&!result.data.error)
                        resolve(result.data.data);
                    else
                        reject('Error');
                },error=>reject(error)).catch(error=>reject(error))
                
        })
    },
    lockAnalysis: async function (id, isLocked) {
        try {
            const { data: { data: updatedAnalysis } } = await EDHttp.put(`/api/v2/analysis/lock/${id}`, { isLocked });
            return updatedAnalysis
        } catch ({ response }) {
            throw response.data.data.message;
        }
    },
}